"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

const isIterable = value => Array.isArray(value) || (0, _lodash.isPlainObject)(value);

const mapDeep = (object, callback, deep = Infinity) => (0, _lodash.reduce)(object, (acc, currentValue, currentKey) => {
  const callbackReturn = callback(currentValue, currentKey, acc) || {};
  let value = currentValue;
  let key = currentKey;
  if ('value' in callbackReturn) value = callbackReturn.value;
  if ('key' in callbackReturn) key = callbackReturn.key;
  acc[key] = deep > 0 && isIterable(value) ? mapDeep(value, callback, deep - 1) : value;
  return acc;
}, (0, _lodash.isArray)(object) ? [] : {});

var _default = mapDeep;
exports.default = _default;